export default __webpack_public_path__ + "static/media/chairperson.cc34a4fd.png";